import React, { useState } from "react";
import { makeStyles, Box, Link as MuiLink } from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";

export default function MenuList({ text, items }) {
  const classes = useStyle();
  const [openItems, setOpenItems] = useState(false);
  return (
    <Box
      onMouseEnter={() => setOpenItems(!openItems)}
      onMouseLeave={() => setOpenItems(!openItems)}
      className={classes.container}
    >
      <Box className={classes.menu_item__container} onClick={() => setOpenItems(!openItems)}>
        <AppsIcon className={classes.menu_item__icon} />
        {text}
      </Box>
      {openItems && (
        <>
          <Box className={classes.list__container} onClick={() => setOpenItems(!openItems)}>
            {items.map((item, index) => (
              <MuiLink href={item.href} className={classes.item__container} key={index}>
                {item.icon}
                <Box className={classes.list__item}>{item.text}</Box>
              </MuiLink>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  menu_item__container: {
    whiteSpace: "nowrap",
    display: "flex",
    cursor: "pointer",
    color: "white",
    width: "fit-content",
    borderRadius: 50,
    fontSize: 16,
    fontWeight: 500,
    alignItems: "center",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      boxShadow: "inset 0 0 100px 100px rgba(255, 255, 255, 0.1)",
    },
  },
  line_break: {
    height: 8,
  },
  menu_item__icon: { marginRight: theme.spacing(1) },
  list__container: {
    marginTop: theme.spacing(1),
    position: "absolute",
    justifyContent: "start",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 12,
    width: "200px",
    boxShadow: "0px 4px 76px rgb(0 0 0 / 15%)",
  },
  list__item: {
    color: "#3E3E3E",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    fontSize: 16,
    fontWeight: 400,
  },
  item__container: {
    display: "flex",
    alignItems: "center",
    color: "black",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      textDecoration: "none",
    },
    paddingLeft: theme.spacing(2),
    cursor: "pointer",
    borderRadius: 12,
  },
}));
